import CrownIcon from "../images/CrownIcon.mjs";

/**
 * App administrator role icon
 * @see {GlyphIcon}
 * @see {CrownIcon}
 */
const AppAdminIcon = class extends CrownIcon {};

export default AppAdminIcon;